import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ProjectRestService} from '../../../api/services/project.rest.service';
import {ProjectApiModel} from '../../../api/models/project.api-model';
import {CurrentUserViewModel} from '../../../core/models/current-user.view-model';
import {VehicleTypeEnum} from '../../../core/enums/vehicle-type.enum';
import {ProjectViewModel} from './project.view-model';
import {VehicleViewModel} from './vehicle.view-model';
import {VehicleRegistrationData, normalizeVehicleRegistrationData} from './vehicle-registration-data';

/**
 * Stateless project creation shared by the garage page and dynamic modals.
 * Dynamic modal components are created from the application modal host, not
 * GarageComponent's instance injector.
 */
@Injectable({providedIn: 'root'})
export class ProjectCreationService {
  constructor(private readonly projectRS: ProjectRestService) {}

  public create(currentUserVM: CurrentUserViewModel, vehicleVM: VehicleViewModel, registration?: VehicleRegistrationData): Observable<ProjectViewModel> {
    const projectVM = ProjectViewModel.create(currentUserVM, vehicleVM, registration ? normalizeVehicleRegistrationData(registration) : undefined);
    return this.projectRS.create(projectVM.toApiModel()).pipe(
      map((projectAM: ProjectApiModel) => this.fromCreatedResponse(projectAM, currentUserVM, vehicleVM)));
  }

  public fromCreatedResponse(projectAM: ProjectApiModel, currentUserVM: CurrentUserViewModel, vehicleVM: VehicleViewModel): ProjectViewModel {
    const createdProject = new ProjectViewModel(projectAM);
    createdProject.vehicle = vehicleVM;
    if (vehicleVM.vehicleType?.code) {
      createdProject.vehicleType = vehicleVM.vehicleType.code as VehicleTypeEnum;
    }
    createdProject.user = currentUserVM;
    createdProject.getApiModel().user = currentUserVM['@id'];
    return createdProject;
  }
}
